import { render, staticRenderFns } from "./MainService.vue?vue&type=template&id=1cc46fa1&scoped=true&"
import script from "./MainService.vue?vue&type=script&lang=js&"
export * from "./MainService.vue?vue&type=script&lang=js&"
import style0 from "./MainService.vue?vue&type=style&index=0&id=1cc46fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc46fa1",
  null
  
)

export default component.exports